//#region src/plugin/browser.ts
var definitions = () => {
	throw new Error("Config plugin definitions are not available in the browser");
};
//#endregion
export { definitions };

//# sourceMappingURL=browser.mjs.map